import moment, { Moment } from 'moment'
import { FormState } from '../components/ApplicationProgress/types'

export const validatePassword = (value: string | null): boolean =>
  !!value && value.length < 8

/**
 * Helper service
 *
 * @param prop
 * @param state
 * @param event
 * @returns
 */
export const handleChange = <T>(
  prop: keyof FormState<T>,
  state: FormState<T>,
  event: React.ChangeEvent<HTMLInputElement>
): FormState<T> => {
  return { ...state, [prop]: event.target.value }
}

export const formatSsn = (value: string | ''): string =>
  value
    .split('')
    .filter((v) => v !== '-')
    .map((v, i) => (i === 3 || i === 5 ? `-${v}` : v))
    .join('')

export const stripCharactersFromPhone = (value: string | null): string => {
  if (!value) return ''
  return value.replace(/[+()-\s]/g, '').trim()
}

/**
 * Validates a US phone
 * @param value
 * @returns
 */
export const phoneVerification = (value: string): boolean => {
  const v = stripCharactersFromPhone(value)
  const matcher = new RegExp(/^1([2-9]){1}([0-9]){2}([2-9]){1}([0-9]){6}/)
  return matcher.test(v) && v.length === 11
}

export const formatPhone = (value: string | null): string => {
  if (!value) return ''
  return value
    .replace(/\D+/g, '')
    .replace(/^1(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export const isSsnError = (error: string): boolean => {
  return error.split(';').shift() === 'property="ssn"'
}

export const isInvalidAddress = (error: string): boolean => {
  return error === 'Invalid address'
}

export const previousDate = (years: number): Date => {
  return getDate(-years)
}

export const futureDate = (years: number): Date => {
  return getDate(years)
}

export const datesBetween = (
  aDate: Date,
  bDate: Date,
  date: Moment
): boolean => {
  return moment(date).isBetween(bDate, aDate)
}

export const getDate = (years: number): Date => {
  return new Date(
    new Date().getFullYear() + years,
    new Date().getMonth(),
    new Date().getDate()
  )
}

export const cityValidation = (value: string): boolean => {
  const matcher = new RegExp("^[a-zA-Z-.' ]+$")
  return matcher.test(value)
}

export const numericMatcher = (value: string): boolean => {
  const matcher = new RegExp('^[0-9]+$')
  return matcher.test(value)
}
